import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { ProfileFields, profileValid } from "@/components/onboarding/ProfileFields";
import { api, errMsg } from "@/lib/api";

export const ProfileStep = ({ onDone }) => {
  const { user, onboarding } = useAuth();
  const p = onboarding?.profile || {};
  const [value, setValue] = useState({ name: p.name || user?.name || "", country: p.country || "", region: p.region || "", language: p.language || "english" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/onboarding/profile", value);
      onDone(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="panel p-6 sm:p-8 space-y-6 rise" data-testid="profile-step">
      <div className="space-y-2">
        <h1 className="text-3xl font-extrabold tracking-tight">Set up your profile</h1>
        <p className="text-sm text-muted-foreground">Pick your language and we'll write every flirty line in it. Private — never shown publicly.</p>
      </div>
      <ProfileFields value={value} setValue={setValue} />
      <button data-testid="profile-continue-button" disabled={!profileValid(value) || busy} onClick={submit}
        className="w-full h-12 rounded-full brand-gradient text-white font-semibold disabled:opacity-40 transition-opacity">
        {busy ? "Saving…" : "Continue"}
      </button>
    </section>
  );
};
